import * as React from "react"
import { cn } from "@/lib/utils"

type TabItem = { value: string; label: string; disabled?: boolean }

export interface TabsProps {
  tabs: TabItem[]
  value?: string
  defaultValue?: string
  onValueChange?: (v: string)=>void
  className?: string
  children?: React.ReactNode
}

export function Tabs({ tabs, value, defaultValue, onValueChange, className, children }: TabsProps) {
  const [internal, setInternal] = React.useState(defaultValue ?? tabs[0]?.value)
  const val = value ?? internal
  const setVal = (v: string)=>{ if(!value) setInternal(v); onValueChange?.(v) }
  return (
    <div className={cn("w-full", className)}>
      <div role="tablist" className="no-scrollbar flex gap-1 overflow-x-auto rounded-md bg-muted p-1">
        {tabs.map(t => (
          <button key={t.value} role="tab" disabled={t.disabled}
            onClick={()=>!t.disabled && setVal(t.value)}
            className={cn("flex-none whitespace-nowrap rounded-md px-2.5 py-1.5 text-xs sm:px-3 sm:text-sm",
              val===t.value ? "bg-background text-foreground shadow" : "text-foreground/70 hover:text-foreground")}
          >{t.label}</button>
        ))}
      </div>
      <div className="mt-3">{children}
        {/* Consumers render TabPanel conditionally by value if quiser */}
      </div>
    </div>
  )
}
